

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { toThousands } from '../../utils/utils';

@Component
export default class SpecialCompetition extends Vue {
    @Prop({ required: true, default: [] })
    private groupNames!: any[];

    @Prop({ required: true, default: [] })
    private competitionList!: any[];

    @Prop({required: false, default: '大赛赛题'})
    public title!: string;

    @Prop({required: false, default: false})
    public isGZS!: boolean;

    @Prop({required: false, default: false})
    public isSXH!: boolean;

    @Prop({required: false, default: false})
    public isZQB!: boolean;

    // 赛题总数小于等于5时，将所有分组展开
    // 2023年9月25日 fixed: 将所有赛题均展开
    @Watch('groupNames')
    watchValue(val: any[]) {
        // if(this.competitionList.length <= 5) {
            this.groupNames.forEach((name, index) => {
                this.activeNames.push(index);
            });
        // }
    }

    private activeNames:any[] = [];

    private getReward(competition) {
        if(competition.id >=966 && competition.id <= 968){
            return competition.rewardType === 1 ? `HK$${toThousands(competition.reward)}` : `${competition.reward}`;
        }
        return competition.rewardType === 1 ? `￥${toThousands(competition.reward)}` : `${competition.reward}`;
    }

    private onClickItem(competition) {
        this.$router.push(`/competitions/${competition.id}`);
    }

    private getAvatars(competition) {
        const { avatarList = [], addition = {} } = competition;
        const list: any[] = [];
        avatarList.forEach(item => {
            list.push(item.avatar);
        });
        if ((addition as any).totalSignupUsers > list.length) {
            while (list.length < 4) {
                list.push('');
            }
        }
        return list;
    }
}
